import generateProductSlug from '@repo/utils/generateProductSlug';
import collectionsMapping from '@content/collectionsMapping';
import { GetInternalLinkFunctionType } from '../../../../../packages/models/GetInternalLinkFunctionType';
import { InternalLinkTypeEnum } from '../../../../../packages/models/InternalLinkTypeEnum';
import { getCollectionMappingKey } from '@util/getCollectionMappingKey';

import {
  SanityBlogPost,
  SanityCollection,
  SanityPage,
  SanityPerson,
  SanityPressRelease,
  SanityProduct,
} from '../../../../../packages/models/gatsby-graphql-types';

const getInternalLink: GetInternalLinkFunctionType = ({ reference }) => {
  if (!reference) return null;

  if ((reference as any)?.collectionSlug) {
    return `/${(reference as any)?.collectionSlug.slug.current}`;
  }

  // eslint-disable-next-line no-underscore-dangle
  switch (reference?._type) {
    case InternalLinkTypeEnum.PAGE:
      return `/${(reference as SanityPage).slug.current}`;

    case InternalLinkTypeEnum.PRODUCT:
    case InternalLinkTypeEnum.GLOBAL_PRODUCT:
      return `/${generateProductSlug({
        productHandle: (reference as SanityProduct).store.slug.current,
        productType: (reference as SanityProduct).store.productType,
      })}`;

    case InternalLinkTypeEnum.PERSON:
      return `/about-us/pro-staff/${(reference as SanityPerson).slug.current}`;

    case InternalLinkTypeEnum.PRESS_RELEASE:
      return `/about-us/press-room/releases/${
        (reference as SanityPressRelease).slug.current
      }`;

    case InternalLinkTypeEnum.BLOG_POST:
      return `/hunting-training-tips/${
        (reference as SanityBlogPost).slug.current
      }`;

    case InternalLinkTypeEnum.GLOBAL_PRODUCT_COLLECTION: {
      const key = getCollectionMappingKey(
        (reference as SanityCollection).store.slug.current,
        (reference as SanityCollection).language
      );

      const value = collectionsMapping.find(
        collection => collection.key === key
      )?.value;

      return value || `/${(reference as SanityCollection).store.slug.current}`;
    }

    default:
      return (reference as SanityPage)?.slug?.current
        ? `/${(reference as SanityPage).slug.current}`
        : '/';
  }
};

export default getInternalLink;
